import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

// react-router v6 dropped the old withRouter HOC and only exposes
// route info via hooks. This wrapper re-creates it so class components
// can still receive params/navigate/location as props.
export default function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    return <Component {...props} params={params} navigate={navigate} location={location} />;
  }
  return ComponentWithRouterProp;
}
